import { Routes, Route, Navigate } from 'react-router-dom'
import { AdminHomePage } from '../../pages/adminHome/adminHome.component'
import { AdminDashBoard } from '../../components/adminDashboard/adminDashboard.component';
import { IdeasReviewList } from '../../layout/ideasReviewList/ideasReviewList.component';
import { IdeaReviewForm } from '../../components/ideaReviewForm/ideaReviewForm.component';
import { JuryDetails } from '../../layout/juryDetails/juryDetails.component';


export const ModeratorAndJuryRoutes = () => {
    return (
        <Routes>
            <Route exact path="/" element={<AdminHomePage />}>
                <Route exact path='/' element={<AdminDashBoard />} />
                <Route exact path='/ideas' element={<IdeasReviewList />} />
                <Route exact path='/ideas/idea-details/:ideaId' element={<IdeaReviewForm />} />
                <Route exact path='/jury-details' element={<JuryDetails/>} />
            </Route>
            <Route path="*" element={<Navigate to={"/"} replace={false} />} />
        </Routes>
    )
}